import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon';
import { Flex } from '@mantine/core';

export const Paginate = <T extends Array<unknown>>({
	onClick,
	pageIndex,
	data,
}: {
	onClick: (nbr: number) => void;
	pageIndex: number;
	data: T;
}) => {
	const canGoBack = pageIndex > 0;
	const canGoForward = pageIndex < data.length - 1;
	return (
		<Flex gap="0.5rem">
			<Icon
				size="2rem"
				variant="arrow-left-circle"
				style={{
					cursor: canGoBack ? 'pointer' : 'not-allowed',
					opacity: canGoBack ? 1 : 0.3,
				}}
				onClick={canGoBack ? () => onClick(pageIndex - 1) : undefined}
			/>
			<Icon
				size="2rem"
				variant="arrow-right-circle"
				style={{
					cursor: canGoForward ? 'pointer' : 'not-allowed',
					opacity: canGoForward ? 1 : 0.3,
				}}
				onClick={canGoForward ? () => onClick(pageIndex + 1) : undefined}
			/>
		</Flex>
	);
};
